import React from 'react';

import styles from './styles.scss';

export default class FieldSet extends React.Component {

    render() {
        return (
            <fieldset className={styles['fieldset']}>
                { this.props.legend && <legend className={styles['legend']}>{ this.props.legend }</legend> }
                { this.props.children }
            </fieldset>
        )
    }
}